import { inject, injectable } from 'inversify';
import NPSService from '../../data/service/NPSService';

type SendNPSUseCaseProps = {
  user_uuid: string;
  score: number;
  observation: string;
};

@injectable()
class SendNPSUseCase {
  @inject(NPSService) private npsService!: NPSService;

  async execute({ user_uuid, score, observation }: SendNPSUseCaseProps) {
    const response = await this.npsService.sendNPS({
      user_uuid,
      score,
      observation,
    });

    return response.data;
  }
}

export default SendNPSUseCase;
